var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { Router } from '@angular/router';
import { LayoutRefService } from '@metronic/app/core/_base/layout/services/layout-ref.service';
import { AppConsts } from '@shared/AppConsts';
var Theme3LayoutComponent = /** @class */ (function (_super) {
    __extends(Theme3LayoutComponent, _super);
    function Theme3LayoutComponent(injector, router, document, layoutRefService) {
        var _this = _super.call(this, injector) || this;
        _this.document = document;
        _this.layoutRefService = layoutRefService;
        _this.remoteServiceBaseUrl = AppConsts.remoteServiceBaseUrl;
        _this.menuCanvasOptions = {
            baseClass: 'kt-aside',
            overlay: true,
            closeBy: 'kt_aside_close_btn',
            toggleBy: [{
                    target: 'kt_aside_mobile_toggler',
                    state: 'kt-header-mobile__toolbar-toggler--active'
                }]
        };
        return _this;
    }
    Theme3LayoutComponent.prototype.ngOnInit = function () {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    };
    Theme3LayoutComponent.prototype.ngAfterViewInit = function () {
        this.layoutRefService.addElement('header', this.ktHeader.nativeElement);
    };
    return Theme3LayoutComponent;
}(ThemesLayoutBaseComponent));
export { Theme3LayoutComponent };
